import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-sidebar-toggle-btn',
  templateUrl: './sidebar-toggle-btn.component.html',
  styleUrls: ['./sidebar-toggle-btn.component.scss']
})
export class SidebarToggleBtnComponent implements OnInit {
  @Input() sidebarOpen: boolean = false;

  @Output() onClick: EventEmitter<any> = new EventEmitter();

  constructor() { }

  ngOnInit(): void {
  }

  clickEvent() {
    this.onClick.emit();
  }
}
